'use client';

import { __awaiter, __generator, __assign } from '../../../_virtual/_tslib.js';
import React__default from 'react';
import { useTranslate } from '../../../Contexts/translator/index.js';
import Form from '../../../Form/index.js';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import Input from '../../../Input/index.js';
import I11lPhoneNumberInput from '../../../I11lPhoneNumberInput/index.js';
import { useOnBoarding } from '../../context/index.js';
import { nationalityList, VIETNAM_COUNTRY_ID, notAllowCityId, INTERNATION_PHONE_NUMBER_END_POINT, MAX_DATE, EGender, EMaritalStatus, INTERNATIONAL_CITY_ID } from '../../const.js';
import DatePicker from '../../../DatePicker/components/DatePicker.js';
import '../../../Calendar/index.js';
import '../../../DatePicker/styles.css.js';
import { EDatePicker } from '../../../DatePicker/type.js';
import '../../../Calendar/types.js';
import { ELanguage } from '../../../Utils/constants.js';
import '../../../DateInput.tsx/index.js';
import 'react-dom';
import '../../../hooks/useMakeSearchable/types.js';
import { updateBasicInfo } from '../../../services/resumes/index.js';
import '../../../services/resumes/types.js';
import MultipleRadio from '../../../MultipleRadio/index.js';
import SingleRadio from '../../../SingleRadio/index.js';
import { getOptions } from '../../helper.js';
import { ImgContainer, Image } from '../../styles.css.js';
import Avatars from '../../../Images/AvatarGroupIcon/index.js';
import { Title } from '../Title.js';

var ContactInfo = function () {
    var _a;
    var t = useTranslate().t;
    var _b = useOnBoarding(), accessToken = _b.accessToken, baseMsUrl = _b.baseMsUrl, lang = _b.lang, countries = _b.countries, cities = _b.cities, districts = _b.districts, user = _b.user, formResumeInfo = _b.formResumeInfo, setFormResumeInfo = _b.setFormResumeInfo, setIsLoading = _b.setIsLoading;
    var nationalityOptions = nationalityList(lang !== null && lang !== void 0 ? lang : ELanguage.VI);
    var validator = Form.validator(t);
    var rules = {
        firstName: validator.string().require().noSpecialChars().generate(),
        lastName: validator.string().require().noSpecialChars().generate(),
        email: validator.string().require().generate(),
        phone: validator.string().require().vnPhoneNumber().internationalPhoneNumber().generate(),
        birthday: validator.string().require().generate(),
        nationalityId: validator.string().require().generate(),
        genderId: validator.string().require().generate(),
        maritalStatusId: validator.string().require().generate(),
        countryId: validator.string().require().generate(),
        cityId: validator
            .number()
            .custom(function (value, watch) {
            if (!value && (watch === null || watch === void 0 ? void 0 : watch.countryId) === VIETNAM_COUNTRY_ID) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        districtId: validator
            .number()
            .custom(function (value, watch) {
            var isCheckCityId = notAllowCityId.includes(watch === null || watch === void 0 ? void 0 : watch.cityId);
            if (watch.countryId !== VIETNAM_COUNTRY_ID || isCheckCityId) {
                return true;
            }
            if (!value && !isCheckCityId && watch.countryId === VIETNAM_COUNTRY_ID) {
                return false;
            }
            return true;
        }, t('This field is required.'))
            .generate(),
        address: validator.string().require().generate()
    };
    var handleUploadResumeInfo = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var body, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!values)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = __assign(__assign({}, values), { salary: Number(values.salary), currentSalary: Number(values.currentSalary) });
                    return [4 /*yield*/, updateBasicInfo(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', body, lang)];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.meta.code) === 200) {
                        setIsLoading(false);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    console.error(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement(Form, { initialValues: formResumeInfo, onSubmit: function (values) { return handleUploadResumeInfo(values); }, getCurrentValues: function (values) {
            setFormResumeInfo(values);
        } },
        React__default.createElement(Row, { gutter: [16, 24], justify: 'center', align: 'middle' },
            React__default.createElement(Col, null,
                React__default.createElement(Title, { title: t('Share a bit about who you are'), subTitle: t("This information plays a key role in introducing you to employers, and it's editable at any time.") })),
            React__default.createElement(Col, null,
                React__default.createElement(ImgContainer, { width: '110px', height: '110px' }, (user === null || user === void 0 ? void 0 : user.profilePicture) ? (React__default.createElement(Image, { src: (_a = user === null || user === void 0 ? void 0 : user.profilePicture) !== null && _a !== void 0 ? _a : '', alt: 'avatar' })) : (React__default.createElement(Avatars.Avatar, { size: 110 })))),
            React__default.createElement(Form.Item, { name: 'firstName', rules: rules.firstName }, function (field) { return (React__default.createElement(Col, { md: 12, xs: 24, ref: field.setItemRef },
                React__default.createElement(Form.Label, null, t('First name')),
                React__default.createElement(Input, { type: 'text', placeholder: t('Enter your firstname'), value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                React__default.createElement(Form.Error, null))); }),
            React__default.createElement(Form.Item, { name: 'lastName', rules: rules.lastName }, function (field) { return (React__default.createElement(Col, { md: 12, xs: 24, ref: field.setItemRef },
                React__default.createElement(Form.Label, null, t('Last name')),
                React__default.createElement(Input, { type: 'text', placeholder: t('Enter your lastname'), value: field.value, onChange: field.onChange, onBlur: function () { return field.onBlur(); }, hasError: field.isError, maxLength: 50 }),
                React__default.createElement(Form.Error, null))); }),
            React__default.createElement(Form.Item, { name: 'email', rules: rules.email }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null, t('Email')),
                    React__default.createElement(Input, { type: 'text', placeholder: t('Enter your email'), value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError, disabled: true, readOnly: true }),
                    React__default.createElement(Form.Error, null)));
            }),
            React__default.createElement(Form.Item, { name: 'phone', rules: rules.phone }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null,
                        " ",
                        t('Phone number')),
                    React__default.createElement(I11lPhoneNumberInput, { value: field.value, placeholder: t('Enter your phone number'), hasError: field.isError, onChange: field.onChange, onBlur: field.onBlur, urlMeta: "".concat(baseMsUrl, "/").concat(INTERNATION_PHONE_NUMBER_END_POINT), language: lang }),
                    React__default.createElement(Form.Error, null)));
            }),
            React__default.createElement(Form.Item, { name: 'birthday', rules: rules.birthday }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null,
                        " ",
                        t('Date of birth')),
                    React__default.createElement(DatePicker, { type: EDatePicker.date, langCode: lang, defaultDate: field.value ? new Date(field.value) : null, onChange: field.onChange, hasError: field.isError, onBlur: field.onBlur, max: MAX_DATE }),
                    React__default.createElement(Form.Error, null)));
            }),
            React__default.createElement(Form.Item, { name: 'nationalityId', rules: rules.nationalityId }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null,
                        " ",
                        t('Nationality')),
                    React__default.createElement(MultipleRadio, { options: nationalityOptions, name: 'nationalityId', placeholder: t('Please select...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, hasError: field.isError, onBlur: field.onBlur }),
                    React__default.createElement(Form.Error, null)));
            }),
            React__default.createElement(Form.Item, { name: 'genderId', rules: rules.genderId }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null,
                        " ",
                        t('Gender')),
                    React__default.createElement(Row, null,
                        React__default.createElement(Col, { xs: 'auto' },
                            React__default.createElement(SingleRadio, { id: 'gender-male', label: t('Male'), onChange: function (value) {
                                    field.onChange(EGender.MALE);
                                }, name: '', isLeftRadio: true, checked: field.value === EGender.MALE, width: 'fit-content' })),
                        React__default.createElement(Col, { xs: 'auto' },
                            React__default.createElement(SingleRadio, { id: 'gender-female', label: t('Female'), onChange: function (value) { return field.onChange(EGender.FEMALE); }, name: 'gender', isLeftRadio: true, checked: field.value === EGender.FEMALE, width: 'fit-content' }))),
                    React__default.createElement(Form.Error, null)));
            }),
            React__default.createElement(Form.Item, { name: 'maritalStatusId', rules: rules.maritalStatusId }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null,
                        " ",
                        t('Marital status')),
                    React__default.createElement(Row, null,
                        React__default.createElement(Col, { xs: 'auto' },
                            React__default.createElement(SingleRadio, { id: 'marital-status-single', label: t('Single'), onChange: function () { return field.onChange(EMaritalStatus.SINGLE); }, name: 'marital-status', isLeftRadio: true, checked: field.value === EMaritalStatus.SINGLE, width: 'fit-content' })),
                        React__default.createElement(Col, { xs: 'auto' },
                            React__default.createElement(SingleRadio, { id: 'marital-status-married', label: t('Married'), onChange: function () { return field.onChange(EMaritalStatus.MARRIED); }, name: 'marital-status', isLeftRadio: true, checked: field.value === EMaritalStatus.MARRIED, width: 'fit-content' }))),
                    React__default.createElement(Form.Error, null)));
            }),
            React__default.createElement(Form.Item, { name: 'countryId', rules: rules.countryId }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null,
                        " ",
                        t('Country')),
                    React__default.createElement(MultipleRadio, { options: countries !== null && countries !== void 0 ? countries : [], name: 'countryId', placeholder: t('Please select...'), value: field.value, onChange: function (item) {
                            field.onChange(item.value);
                            if (item.value !== VIETNAM_COUNTRY_ID) {
                                field.setFieldValue('cityId', INTERNATIONAL_CITY_ID);
                                return;
                            }
                            field.setFieldValue('cityId', undefined);
                        }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                            maxHeight: '330px',
                            isSearchable: true,
                            emptyText: t('No Result Found'),
                            searchBoxPlaceholder: t('Search')
                        } }),
                    React__default.createElement(Form.Error, null)));
            }),
            React__default.createElement(Form.Item, { name: 'cityId', watch: ['countryId'], rules: rules.cityId }, function (field) {
                var _a, _b, _c;
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === VIETNAM_COUNTRY_ID }, t('Province/City')),
                    React__default.createElement(MultipleRadio, { options: cities !== null && cities !== void 0 ? cities : [], name: 'cityId', placeholder: t('Please select...'), value: field.value, onChange: function (item) {
                            field.setFieldValue('districtId', undefined);
                            field.onChange(item.value);
                        }, onBlur: field.onBlur, disable: !(((_b = field === null || field === void 0 ? void 0 : field.watch) === null || _b === void 0 ? void 0 : _b.countryId) === VIETNAM_COUNTRY_ID), hasError: field.isError, dropdown: {
                            maxHeight: '330px',
                            isSearchable: true,
                            emptyText: t('No Result Found'),
                            searchBoxPlaceholder: t('Search')
                        } }),
                    React__default.createElement(Form.Error, { disable: !(((_c = field === null || field === void 0 ? void 0 : field.watch) === null || _c === void 0 ? void 0 : _c.countryId) === VIETNAM_COUNTRY_ID) })));
            }),
            React__default.createElement(Form.Item, { name: 'districtId', watch: ['countryId', 'cityId'], rules: rules.districtId }, function (field) {
                var _a, _b, _c, _d, _e, _f, _g;
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, { require: ((_a = field.watch) === null || _a === void 0 ? void 0 : _a.countryId) === VIETNAM_COUNTRY_ID &&
                            !notAllowCityId.includes((_b = field.watch) === null || _b === void 0 ? void 0 : _b.cityId) }, t('District')),
                    React__default.createElement(MultipleRadio, { options: getOptions(districts === null || districts === void 0 ? void 0 : districts[(_c = field.watch) === null || _c === void 0 ? void 0 : _c.cityId], lang), name: 'District', placeholder: t('Please select...'), value: field.value, onChange: function (item) { return field.onChange(item.value); }, onBlur: field.onBlur, hasError: field.isError, dropdown: {
                            maxHeight: '330px',
                            isSearchable: true,
                            emptyText: t('No Result Found'),
                            searchBoxPlaceholder: t('Search')
                        }, disable: !(((_d = field.watch) === null || _d === void 0 ? void 0 : _d.countryId) === VIETNAM_COUNTRY_ID) ||
                            notAllowCityId.includes((_e = field.watch) === null || _e === void 0 ? void 0 : _e.cityId) }),
                    React__default.createElement(Form.Error, { disable: !(((_f = field.watch) === null || _f === void 0 ? void 0 : _f.countryId) === VIETNAM_COUNTRY_ID) ||
                            notAllowCityId.includes((_g = field.watch) === null || _g === void 0 ? void 0 : _g.cityId) })));
            }),
            React__default.createElement(Form.Item, { name: 'address', rules: rules.address }, function (field) {
                return (React__default.createElement(Col, { xs: 24, md: 12, ref: field.setItemRef },
                    React__default.createElement(Form.Label, null,
                        " ",
                        t('Address')),
                    React__default.createElement(Input, { type: 'text', placeholder: t('Enter your address'), value: field.value, onChange: field.onChange, onBlur: field.onBlur, hasError: field.isError }),
                    React__default.createElement(Form.Error, null)));
            }))));
};

export { ContactInfo, ContactInfo as default };
//# sourceMappingURL=index.js.map
